import React, { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import ApiUserManager from "../../../../../../core/api/api.userManager";
import SwalMessage from "../../../../_Components/SwalMessage";

function EditOrderPerson(props) {
  const [show, setShow] = useState(true);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const person = props.person;

  // ---------------------------------------------------------------------------------------------
  const handleClose = () => {
    setShow(!show);
    props.callBack();
  };
  // ---------------------------------------------------------------------------------------------------
  const onSubmit = async (data) => {
    const dataForUpdata = {
      basketId: props.basketId,
      id: person.id,
      firstName: data.name,
      lastName: data.family,
    };
    const response = await ApiUserManager.updateUserSite(dataForUpdata);
    SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    handleClose();
  };

  return (
    <Modal show={show} size="md" onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>ویرایش سفارش دهنده</Modal.Title>
      </Modal.Header>
      <Form id="form" onSubmit={handleSubmit(onSubmit)} className=" border border-top-0  border-bottom-radius">
        <Modal.Body>
          <Row>
            <Col sm="4" className=" py-3  d-none d-lg-block">
              <p className="pl-5  ">نام :</p>
            </Col>
            <Col sm="10" lg="7" className="mx-sm-auto my-sm-3 mx-lg-0 my-lg-0">
              <Form.Control
                size="sm"
                type="text"
                defaultValue={person.firstName}
                {...register("name", { required: true })}
              />
              <div className="my-1 py-1">
                {errors.name && <span className="text-danger my-2 py-2">این فیلد الزامی است.</span>}
              </div>
            </Col>
          </Row>
          <Row>
            <Col sm="4" className="py-3 d-none d-lg-block">
              <p className="pl-5  "> نام خانوادگی :</p>
            </Col>
            <Col sm="10" lg="7" className="mx-sm-auto my-sm-3 mx-lg-0 my-lg-0">
              <Form.Control
                size="sm"
                type="text"
                defaultValue={person.lastName}
                {...register("family", { required: true })}
              />
              <div className="my-1 py-1">
                {errors.family && <span className="text-danger my-2 py-2">این فیلد الزامی است.</span>}
              </div>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" type="submit">
            <SaveIcon />
            ذخیره
          </Button>
          <Button variant="danger" onClick={handleClose}>
            <CloseIcon />
            بستن
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default EditOrderPerson;
